import { CardType, CategoryType } from 'types/deck'

import { alpha } from 'redux/deck/helpers/sorting'

export function generateMTGODekFile(cards: CardType[] = [], categoryMap: Record<string, CategoryType>): string {
  const deck = [...cards].sort(alpha)

  let output = ''

  output += '<?xml version="1.0" encoding="utf-8"?>\n'
  output += `<Deck xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">\n`

  output += `  <NetDeckID>0</NetDeckID>\n`
  output += `  <PreconstructedDeckID>0</PreconstructedDeckID>\n`

  for (const card of deck) {
    const categoryName = card?.categories[0] || ''
    const primaryCategory = categoryMap[categoryName]

    const sideboard = primaryCategory?.name === 'Sideboard' || primaryCategory.isPremier // MTGO puts commanders in the sideboard

    const quantity = card.qty
    const catId = card.ids.mtgoNormalId
    const name = card?.front?.name || card.name

    output += `  <Cards CatID="${catId}" Quantity="${quantity}" Sideboard="${sideboard}" Name="${name}" />\n`
  }

  output += `</Deck>\n`

  return output
}
